import React, { forwardRef, ReactNode } from 'react';
import classNames from 'classnames';

const Container = forwardRef((props, ref) => {
	// eslint-disable-next-line react/prop-types
	const { children, className, breakpoint = 'container', ...rest } = props;

	return (
		<div
			ref={ref}
			data-component-name='Container'
			className={classNames('mx-auto p-4', breakpoint, className)}
			{...rest}>
			{children}
		</div>
	);
});
Container.displayName = 'Container';

export default Container;
